/* React Higher Order Component which provides assignment play button onClick functionality for active assignment attempt for user where assignment = props.instanceHash
    Child (InnerComponent) will only render if assignment data is successfully fetched and state.warningText is not ''
    child will receive props: {
        instanceHash: PropTypes.string,
        contentBlockHash: PropTypes.string,
        shortCourseInstanceStoreState: PropTypes.shape({ shortCourseInstance: PropTypes.object, ... })
        playActionId: PropTypes.string, (or null)
        onClick: PropTypes.func,
        onErrorClick: PropTypes.func,
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ReactUtil = require('../../util/ReactUtil');
const Globals = require('../../../../app/globals');
const ShortCourseInstanceActions = require('../../actions/ShortCourseInstanceActions');
const ShortCourseInstanceStore = require('../../stores/ShortCourseInstanceStore');
import WarningBox from '../common/WarningBox';

const propTypes = {
    instanceHash: PropTypes.string.isRequired,
    contentBlockHash: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    integrationType: PropTypes.string
};

const defaultProps = {
    integrationType: '',
    attempt: ''
};

export default function withContentBlockPlayButton(WrappedComponent) {
    class WithContentBlockPlayButton extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                shortCourseInstanceStoreState: ShortCourseInstanceStore.getStateShortCourseInstance(props.instanceHash),
                playActionId: null,
                warningText: ''
            };

            this.onWithPlayButtonClick = this.onWithPlayButtonClick.bind(this);
            this.onErrorSituationClick = this.onErrorSituationClick.bind(this);
            this.closeWarningBox = this.closeWarningBox.bind(this);
            this.unsubscribe = ShortCourseInstanceStore.listen(this.onShortCourseInstanceStoreStateChange.bind(this));
        }

        componentWillUnmount() {
            this.unsubscribe();
        }

        onWithPlayButtonClick(e) {
            if (!!this.state.playActionId) {
                return;
            }

            const actionId = uuid.v4();
            this.setState({ playActionId: actionId }, () => {
                ShortCourseInstanceActions.playShortCourseInstanceContentBlock(
                    actionId,
                    {
                        instanceHash: this.props.instanceHash,
                        contentBlockHash: this.props.contentBlockHash,
                        nodeId: this.props.courseNodeInstance && this.props.courseNodeInstance.node_id,
                        integrationType: this.state.shortCourseInstanceStoreState.shortCourseInstance.integration_type
                    }
                );
            });
        }

        onErrorSituationClick(e) {
            this.setState({ warningText: 'An error was encountered during processing of this attempt. Administrators have been notified.' });
        }

        closeWarningBox(e) {
            this.setState({ warningText: '' });
        }

        onShortCourseInstanceStoreStateChange(state) {
            const newState = ShortCourseInstanceStore.getStateShortCourseInstance(this.props.instanceHash);
            if (!!state.action.id && state.action.id === this.state.playActionId) {
                if (
                    !!newState.playUrls[this.props.contentBlockHash]
                    && !!!!newState.playUrls[this.props.contentBlockHash].playUrl
                ) { //just received playUrl
                    this.setState({ shortCourseInstanceStoreState: newState, playActionId: null }, () => {
                        let playViewUrl;
                        switch (this.props.integrationType) {
                            case Globals.integration_type.CONNECT:
                                playViewUrl = `/`; // TODO not implemented
                                break;
                            default:
                                playViewUrl = `/course_instance/${this.props.instanceHash}/${this.props.contentBlockHash}/play`;

                        }

                        this.props.history.push(playViewUrl);
                    });

                    return;
                }
                else {
                    this.setState({ shortCourseInstanceStoreState: newState, playActionId: null });
                }
            }
            else {
                this.setState({ shortCourseInstanceStoreState: newState});
            }
        }

        render() {
            if (this.state.warningText) {
                return (
                    <WarningBox><span onClick={this.closeWarningBox}>{this.state.warningText}</span></WarningBox>
                )
            }

            if (!this.state.shortCourseInstanceStoreState.shortCourseInstance) {
                return null;
            }

            return (
                <WrappedComponent
                    onClick={this.onWithPlayButtonClick}
                    onErrorClick={this.onErrorSituationClick}
                    {...this.state}
                    {...this.props}
                />
            );
        }
    }

    WithContentBlockPlayButton.propTypes = propTypes;
    WithContentBlockPlayButton.defaultProps = defaultProps;
    WithContentBlockPlayButton.displayName = `WithContentBlockPlayButton(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithContentBlockPlayButton;
}